import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import { ModalNotifyService } from '../../../../core/services/modal-notify.service';
import { FileUploadResponse } from '../../../models/dto/file-upload-response';
import { FileData } from '../../../models/file-data';
import { environment } from 'src/environments/environment';
import { SsoStrategyService } from 'src/app/sso-strategy.service';

declare var $: any;

export const TEXT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FileInputComponent),
  multi: true
};
declare var recuperaTokenCSRF;
@Component({
    selector: '[file_input]',
  templateUrl: 'file-input.component.html',
  providers: [TEXT_VALUE_ACCESSOR, NgbTooltipConfig]
})

export class FileInputComponent implements ControlValueAccessor {

  @Input()
  buttonText: string;

  @Input()
  location: string;

  @Input()
  inputId: string;

  @Input()
  action: string;

  @Input()
  urlUploadDocumento: string;

  @Input()
  fileUploadedName: string;

  @ViewChild('fileInput')
  fileInput: ElementRef;

  @Output()
  onReturn = new EventEmitter();

  @Output()
  onUpload = new EventEmitter();

  @Output()
  onDeleteFile = new EventEmitter();

  @Output()
  onUploadError = new EventEmitter();

  static ToolTipElement;


  @Input()
  fileUploaded: boolean = false;
  private _value: string;
  private input: any;
  private fileToUpload: File;
  private fileData: FileData;
  private subscription: Subscription = null;
  private onTouchedCallback: () => void = () => { };
  private onChangeCallback: (_: any) => void = () => { };
  private randomValueString: string;
  private XSRF: string;
  private modalNotifyService: ModalNotifyService;
  @ViewChild('t') el: ElementRef;
  constructor(private httpService: HttpClient, private modalNotify: ModalNotifyService, private ssoStrategy: SsoStrategyService) {
    this.randomValueString = '' + Math.round(Math.random() * 100000);
    this.modalNotifyService = modalNotify;
  }

  ngOnChanges() {
    this.resetComponent();
  }

  resetComponent() {
    this.fileUploaded = false;
    this.fileUploadedName = '';
    if (FileInputComponent.ToolTipElement) {
      FileInputComponent.ToolTipElement.close();
    }
  }

  onChangeUpload(event, t) {
    t.close();
    if (event && event.target && event.target.files) {
      this.fileToUpload = event.target.files[event.target.files.length - 1];
      if (this.action == 'insert') {
        console.log(this.fileToUpload);
        this.uploadFile(this.fileToUpload);
      }
      else if (this.action == 'update') {
        this.fileUploaded = true;
        this.fileUploadedName = this.fileToUpload.name;
        this.onUpload.emit(this.fileToUpload);
      }
    }
  }

  uploadFile(file: File): Promise<any> {
    FileInputComponent.ToolTipElement = this.el;
    FileInputComponent.ToolTipElement.close();
    this.XSRF = this.getXSRFToken()['XSRF-TOKEN'];


    return new Promise((resolve, reject) => {
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(this.fileData = (<FileUploadResponse>JSON.parse(xhr.response)).fileData);
            console.log('OK upload');
            this.fileUploaded = true;
            this.fileUploadedName = this.fileData.nomeFile;
            this.onReturn.emit(this.fileData);
          } else {
            this.fileUploaded = false;
            this.fileUploadedName = '';
            this.modalNotifyService.customMessage(xhr.response);
            this.onUploadError.emit(xhr.response);
            //            console.log('UPLOAD KO RESPONSE:');
            //            console.log(JSON.parse(xhr.response));
            reject(xhr.response);
          }
        }
      };
      xhr.addEventListener('error', this.transferFailed, false);
      xhr.addEventListener('abort', this.transferCanceled, false);
      xhr.open('POST', this.urlUploadDocumento, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader('X-XSRF-TOKEN', this.XSRF);
      if(this.ssoStrategy.getAuthMode() === "oauth2") {
        xhr.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('access_token')}`);
      }
      let formData = new FormData();
      formData.append('contenuto', file);
      formData.append('nomeFile', file.name);
      console.log(formData);
      xhr.send(formData);
    });
  }

  transferFailed(evt) {
    FileInputComponent.ToolTipElement.ngbTooltip = PropertiesSettings.TRANSFER_UPLOAD_ERROR;
    FileInputComponent.ToolTipElement.open();
  }

  transferCanceled(evt) {
    FileInputComponent.ToolTipElement.ngbTooltip = PropertiesSettings.CANCEL_UPLOAD_ERROR;
    FileInputComponent.ToolTipElement.open();
  }

  errorCallback(response, t): any {
    t.ngbTooltip = JSON.parse(response);
    t.open();
  }

  deleteFile() {
    this.fileUploaded = false;
    this.fileUploadedName = '';
//    if (this.action == 'insert') {

      this.onDeleteFile.emit();
//    }
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  getXSRFToken = () =>
  document.cookie.split('; ').reduce((acc, value) => {
    const cookie = value.split('=');
    acc[cookie[0]] = cookie[1];
    return acc;
  }, {});
}
